import React from "react";
import styles from "./OfferTableHeader.module.css";

export const OfferTableHeader: React.FC = () => {
    return <div className={styles.wrapper}>
        <span className={styles.titleCell}>Title & Description</span>
        <span className={styles.typeCell}>Type</span>
        <span className={styles.vehicleCell}>Vehicle</span>
        <span className={styles.datesCell}>Dates</span>
        <span className={styles.valueCell}>Value</span>
        <span className={styles.sourceCell}>Source</span>
        <span className={styles.actionsCell}>Actions</span>
    </div>
}
